import AccountSettings from "@/pages/(app)/account-settings/page.tsx";
import CustomerPortalPage from "@/pages/(app)/customer-portal/page";
import EmbedLayout from "@/pages/(app)/embed/layout.tsx";
import EmbedPage from "@/pages/(app)/embed/page.tsx";
import IntegrationsPage from "@/pages/(app)/integrations/page";
import AdminLayout from "@/pages/(app)/admin/layout";
import AdminPage from "@/pages/(app)/admin/page";
import { AdminMonitoringEventsPage } from "@/pages/(app)/admin/monitoring-events-page";
import {
  AdminProductRecommendationsPage,
  AdminShopAccessLogPage,
  AdminShopPiiLookupPage,
} from "@/pages/(app)/admin/admin-shop-screens";
import { AdminDashboardPage } from "@/pages/(app)/admin/dashboard-page";
import { AdminShopDetailPage } from "@/pages/(app)/admin/shop-detail";
import {
  AdminCarrierIssuesPage,
  AdminCustomerPortalPage,
  AdminPiiBackfillPage,
  AdminPiiRepairPage,
  AdminReplayCreationActionsPage,
  AdminStorefrontEmbedPage,
  AdminSuperAdminsPage,
} from "@/pages/(app)/admin/admin-tab-pages";
import AppLayout from "@/pages/(app)/layout";
import ReturnLayout from "@/pages/(app)/returns/view/layout.tsx";
import ReturnPage from "@/pages/(app)/returns/view/page";
import ShopLayout from "@/pages/(app)/shop/layout";
import AuthLayout from "@/pages/(auth)/layout.tsx";
import SignInPage from "@/pages/(auth)/sign-in/page.tsx";
import SignUpPage from "@/pages/(auth)/sign-up/page.tsx";
import SignUpSuccessPage from "@/pages/(auth)/sign-up-success/page.tsx";
import VerifyEmailPage from "@/pages/(auth)/verify-email/page.tsx";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import ShopSettingsPage from "./components/shop-informations-settings-form/shop-settings";
import NotificationsConfigurationPage from "./pages/(app)/notifications/configuration/page";
import ReturnEmailTemplatesListPage from "./pages/(app)/notifications/email-templates/list-page";
import ReturnEmailTemplateEditorPage from "./pages/(app)/notifications/email-templates/editor-page";
import ReturnWorkflowsPage from "./pages/(app)/notifications/workflows/workflows-page";
import ReturnWorkflowWebhooksPage from "./pages/(app)/notifications/webhooks/page";
import DisapprovalReasonsPage from "./pages/(app)/notifications/disapproval-reasons/page";
import PageBillings from "./pages/(app)/billings/page";
import GiftCodes from "./pages/(app)/gift-codes";
import McpPage from "./pages/(app)/mcp";
import Home from "./pages/(app)/home";
import ReturnsLayout from "./pages/(app)/returns/layout";
import ReturnsPage from "./pages/(app)/returns/list/page";
import ShopsPage from "./pages/(app)/shops/page";
import ForgotPassword from "./pages/(auth)/forgot-password";
import Carriers from "./pages/carriers/carriers";
import AutologinPage from "./pages/(app)/autologin/autologin";
import { ResetPassword } from "./pages/(auth)/reset-password/page";
import { SettingsLayout } from "./components/settings-layout";
import AskPage from "./pages/(app)/ask/ask-page";
import OperationalDashboard from "./pages/(app)/operational-dashboard";
import ForceLogout from "./pages/(auth)/force-logout";
import GorgiasConnectPage from "./pages/gorgias/connect/page";
import AnalyticsLayout from "./pages/(app)/analytics/layout";
import AnalyticsPage from "./pages/(app)/analytics";
import SizingPage from "./pages/(app)/analytics/sizing";
import SizingExperimentsPage from "./pages/(app)/sizing/experiments";
import SizingExperimentResultsPage from "./pages/(app)/sizing/experiments/[experimentId]";
import SizingGuidesPage from "./pages/(app)/sizing/guides";
import SizingSimulatorPage from "./pages/(app)/sizing/simulator";
import SizingInstallPage from "./pages/(app)/sizing/install";
import ManualSizeBiasPage from "./pages/(app)/sizing/manual-bias";
import ProductRecommendationsPage from "./pages/(app)/analytics/product-recommendations";
import PiiLookupPage from "./pages/(app)/pii-lookup";
import AlertsSettingsPage from "./pages/(app)/settings-alerts/page";
import AuditLogPage from "./pages/(app)/settings-audit-log/page";
import BabackAccessLogPage from "./pages/(app)/baback-access-log/page";
import CustomerUiDemoPage from "./pages/customer-ui-demo";
import { FedexRatesValidationPage } from "./pages/fedex-rates-validation";
import { FedexRegistrationValidationPage } from "./pages/fedex-registration-validation";
import { ReturnWidgetLayout } from "./pages/return-widget/components/layout";
import { ReturnWidgetOrderIdentification } from "./pages/return-widget/components/order-identification";
import { ReturnWidgetOrderLayout } from "./pages/return-widget/components/order-layout";
import { NewReturnGate } from "./pages/return-widget/components/new-return-gate";
import { LineItemLayout } from "./pages/return-widget/components/line-item/layout";
import { Reason } from "./pages/return-widget/components/line-item/reason";
import { Resolution } from "./pages/return-widget/components/line-item/resolution";
import { ProductSelection } from "./pages/return-widget/components/line-item/product-selection";
import { ResolutionOptions } from "./pages/return-widget/components/line-item/resolution-options";
import { LineItemSelection } from "./pages/return-widget/components/line-item/line-item-selection";
import { ReturnRequestsList } from "./pages/return-widget/components/return-requests/return-requests-list";
import { ReturnRequestDetails } from "./pages/return-widget/components/return-requests/details";
import { ReturnRequestsLayout } from "./pages/return-widget/components/return-requests/layout";
import { CancelComplete } from "./pages/return-widget/components/return-requests/cancel-complete";
import { ReturnRequestSummary } from "./pages/return-widget/components/summary";
import { ReturnMode } from "./pages/return-widget/components/return-mode";
import { NoPhysicalReturn } from "./pages/return-widget/components/no-physical-return";
import {
  RetractationArticleSelectionPage,
  RetractationSummaryPage,
  GiftIdentificationPage,
  GiftAddressPage,
  GiftCompletePage,
} from "@babackapp/return-widget-components";
import { ReturnWidgetAddressCheck } from "./pages/return-widget/components/address-check";
import { Checkout } from "./pages/return-widget/components/checkout";
import { ReturnRequestComplete } from "./pages/return-widget/components/complete";
import { ShopNowPage } from "./pages/return-widget/components/shop-now";
import { ShopNowResolvePage } from "./pages/return-widget/components/shop-now-resolve";
import { ShopNowRemainingCreditPage } from "./pages/return-widget/components/shop-now-remaining-credit";
import { RebuyBanner } from "./pages/rebuy-banner";

// craftsman-ignore: TS002
export default function Router() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/force-logout" element={<ForceLogout />} />
        <Route path="/autologin" element={<AutologinPage />} />
        <Route path="/gorgias/connect" element={<GorgiasConnectPage />} />
        <Route
          path="/login"
          element={<Navigate to="/auth/sign-in" replace />}
        />
        <Route path="/auth" element={<AuthLayout />}>
          <Route path="sign-in" element={<SignInPage />} />
          <Route path="sign-up" element={<SignUpPage />} />
          <Route path="sign-up-success" element={<SignUpSuccessPage />} />
          <Route path="verify-email" element={<VerifyEmailPage />} />
          <Route path="forgotpassword" element={<ForgotPassword />} />
          <Route path="resetpassword" element={<ResetPassword />} />
        </Route>
        <Route path="o" element={<EmbedLayout />}>
          <Route index element={<EmbedPage />} />
        </Route>
        <Route path="/" element={<AppLayout />} loader>
          <Route index element={<ShopsPage />} />
          <Route path="admin" element={<AdminLayout />}>
            <Route index element={<Navigate to="dashboard" replace />} />
            <Route path="dashboard" element={<AdminDashboardPage />} />
            <Route path="shops" element={<AdminPage />} />
            <Route path="shops/:shopId" element={<AdminShopDetailPage />} />
            <Route
              path="shops/:shopId/events"
              element={<AdminMonitoringEventsPage />}
            />
            <Route path="events" element={<AdminMonitoringEventsPage />} />
            <Route
              path="shops/:shopId/access-log"
              element={<AdminShopAccessLogPage />}
            />
            <Route
              path="shops/:shopId/pii-lookup"
              element={<AdminShopPiiLookupPage />}
            />
            <Route
              path="shops/:shopId/product-recommendations"
              element={<AdminProductRecommendationsPage />}
            />
            <Route
              path="product-recommendations"
              element={<AdminProductRecommendationsPage />}
            />
            <Route path="carrier-issues" element={<AdminCarrierIssuesPage />} />
            <Route
              path="replay-creation-actions"
              element={<AdminReplayCreationActionsPage />}
            />
            <Route
              path="customer-portal"
              element={<AdminCustomerPortalPage />}
            />
            <Route path="pii-vault" element={<AdminPiiBackfillPage />} />
            <Route path="pii-vault/repair" element={<AdminPiiRepairPage />} />
            <Route
              path="storefront-embed"
              element={<AdminStorefrontEmbedPage />}
            />
            <Route path="super-admins" element={<AdminSuperAdminsPage />} />
          </Route>
          {/* Outside any shop: a super admin without MFA must reach it (BAB-3035). */}
          <Route path={"account/settings"} element={<AccountSettings />} />
          <Route path={"shops/:shopId"} element={<ShopLayout />}>
            <Route index element={<Home />} />
            <Route path={"operations"} element={<OperationalDashboard />} />

            <Route path={"returns"} element={<ReturnsLayout />}>
              <Route index element={<ReturnsPage />} />
              <Route path={":returnId"} element={<ReturnLayout />}>
                <Route index element={<ReturnPage />} />
              </Route>
            </Route>
            <Route path={"analytics"} element={<AnalyticsLayout />}>
              <Route index element={<AnalyticsPage />} />
            </Route>
            <Route path={"sizing"}>
              <Route index element={<Navigate to="dashboard" replace />} />
              <Route path="dashboard" element={<SizingPage />} />
              <Route path="experiments" element={<SizingExperimentsPage />} />
              <Route
                path="experiments/:experimentId"
                element={<SizingExperimentResultsPage />}
              />
              <Route path="guides" element={<SizingGuidesPage />} />
              <Route path="simulator" element={<SizingSimulatorPage />} />
              <Route path="install" element={<SizingInstallPage />} />
              <Route path="manual-bias" element={<ManualSizeBiasPage />} />
            </Route>
            <Route path={"analytics/sizing"} element={<SizingPage />} />
            <Route
              path={"analytics/product-recommendations"}
              element={<ProductRecommendationsPage />}
            />
            {/* Super admins only, the page redirects anyone else. */}
            <Route path={"pii-lookup"} element={<PiiLookupPage />} />
            {/* Unlisted on purpose: the API route is disabled (BAB-3012), the
                page is kept for a possible rewrite. */}
            <Route path={"ask"} element={<AskPage />} />
            <Route path="gift-codes" element={<GiftCodes />} />
            {/* Unlisted on purpose: no sidebar entry, reached by URL only. */}
            <Route path="mcp" element={<McpPage />} />
            <Route path={"settings"} element={<SettingsLayout />}>
              <Route
                path="shop-informations"
                element={<ShopSettingsPage />}
                index
              />
              <Route path="customer-portal" element={<CustomerPortalPage />} />
              <Route path="notifications">
                <Route
                  index
                  element={<Navigate to="configuration" replace />}
                />
                <Route
                  path="configuration"
                  element={<NotificationsConfigurationPage />}
                />
                <Route path="email-templates">
                  <Route index element={<ReturnEmailTemplatesListPage />} />
                  <Route
                    path=":templateId"
                    element={<ReturnEmailTemplateEditorPage />}
                  />
                </Route>
                <Route path="workflows">
                  <Route index element={<ReturnWorkflowsPage />} />
                  <Route path=":workflowId" element={<ReturnWorkflowsPage />} />
                </Route>
                <Route
                  path="webhooks"
                  element={<ReturnWorkflowWebhooksPage />}
                />
                <Route
                  path="disapproval-reasons"
                  element={<DisapprovalReasonsPage />}
                />
              </Route>

              {["integrations", "integrations/stripe"].map((r) => (
                <Route key={r} path={r} element={<IntegrationsPage />} />
              ))}
              <Route path="carriers" element={<Carriers />} />
              <Route path="billing" element={<PageBillings />} />
              <Route path="alerts" element={<AlertsSettingsPage />} />
              <Route path="audit-log" element={<AuditLogPage />} />
              <Route path="baback-access" element={<BabackAccessLogPage />} />
              <Route path="gift-codes" element={<div>Gift Code</div>} />
            </Route>

            <Route path={"account/settings"} element={<AccountSettings />} />
          </Route>
        </Route>
        <Route path="/customer-ui-demo" element={<CustomerUiDemoPage />} />
        {import.meta.env.DEV && (
          <>
            <Route
              path="/fedex-rates-validation"
              element={<FedexRatesValidationPage />}
            />
            <Route
              path="/fedex-registration-validation"
              element={<FedexRegistrationValidationPage />}
            />
          </>
        )}
        <Route path="/return-widget/:shopId" element={<ReturnWidgetLayout />}>
          <Route index element={<ReturnWidgetOrderIdentification />} />
          <Route path="gift" element={<GiftIdentificationPage />} />
          <Route path="gift/address" element={<GiftAddressPage />} />
          <Route path="gift/complete" element={<GiftCompletePage />} />
          <Route path="order/:orderId" element={<ReturnWidgetOrderLayout />}>
            <Route index element={<Navigate replace to="return-requests" />} />
            <Route path="return-requests" element={<ReturnRequestsLayout />}>
              <Route index element={<ReturnRequestsList />} />
              <Route
                path=":returnRequestId"
                element={<ReturnRequestDetails />}
              />
              <Route path="cancel-complete" element={<CancelComplete />} />
            </Route>
            <Route path="complete" element={<ReturnRequestComplete />} />
            <Route element={<NewReturnGate />}>
              <Route path="return-mode" element={<ReturnMode />} />
              <Route path="no-physical-return" element={<NoPhysicalReturn />} />
              <Route
                path="retractation-article-selection"
                element={<RetractationArticleSelectionPage />}
              />
              <Route
                path="retractation-summary"
                element={<RetractationSummaryPage />}
              />
              <Route path="summary" element={<ReturnRequestSummary />} />
              <Route path="address" element={<ReturnWidgetAddressCheck />} />
              <Route path="checkout" element={<Checkout />} />
              <Route path="shop-now" element={<ShopNowPage />} />
              <Route path="shop-now-resolve" element={<ShopNowResolvePage />} />
              <Route
                path="shop-now-remaining-credit"
                element={<ShopNowRemainingCreditPage />}
              />
              <Route path="line-item" element={<LineItemLayout />}>
                <Route index element={<LineItemSelection />} />
                <Route path=":lineItemId">
                  <Route path="reason" element={<Reason />} />
                  <Route path="resolution" element={<Resolution />} />
                  <Route
                    path="product-selection"
                    element={<ProductSelection />}
                  />
                  <Route
                    path="resolution-options"
                    element={<ResolutionOptions />}
                  />
                </Route>
              </Route>
            </Route>
          </Route>
        </Route>
        <Route path="/rebuy-banner/:shopId" element={<RebuyBanner />} />
        <Route path="*" element={<Navigate replace to="/" />} />
      </Routes>
    </BrowserRouter>
  );
}
